import adminMenu from './adminMenu';
import mainMenu from './mainMenu';

const fullMenu = [...mainMenu, ...adminMenu];

export default fullMenu;
